import LogoNovaLight from './LogoNovaLight.svg';
import LogoTB from './LogoTB.svg';
import LogoCol from './LogoCol.svg';
import LogoMT from './LogoMT.png';
import LogoPos from './LogoPos.png';
import LogoVaisandLight from './LogoVaisandLight.svg';

const logoMap = {
    matteTheme: LogoMT,
    tecnoTheme: LogoTB,
    novaTheme: LogoNovaLight,
    posTheme: LogoPos,
    colTheme: LogoCol,
    vaisandTheme: LogoVaisandLight,
};

export const getLogo = (theme) => {
    return logoMap[theme] || logoMap.novaTheme;
};
